module.exports = __webpack_public_path__ + "static/media/foto_perfil_defecto.4a9f5ace.png";